import { formatMoney } from '../core/math';
import type { Store } from '../state/Store';
import { isWoman } from '../content/looks';
import { rankFor } from '../state/rules';
import { clear, h, layer } from './dom';

export class EndScreen {
  readonly el: HTMLDivElement;
  private readonly panel: HTMLDivElement;

  constructor(parent: HTMLElement) {
    this.el = layer();
    this.panel = h('div', { class: 'modal end cardboard', attrs: { role: 'dialog', 'aria-modal': 'true' } });
    this.el.append(this.panel);
    parent.append(this.el);
  }

  get isOpen(): boolean {
    return !this.el.hidden;
  }

  show(
    kind: 'evicted' | 'won',
    store: Store,
    actions: { primary: [string, () => void]; secondary: [string, () => void] },
  ): void {
    clear(this.panel);
    const s = store.state;
    const { rank } = rankFor(store.rating(), isWoman(s.player.look));
    const won = kind === 'won';
    const stats: Array<[string, string]> = [
      [':calendar: Days survived', String(s.time.day)],
      [':medal: Final rank', rank.title],
      [':beer: Beers cracked', String(s.counters.beers ?? 0)],
      [':empty-can: Cans recycled', String(s.counters.cansRecycled ?? 0)],
      [':trophy: Trophies', `${s.achievements.length}`],
      [':cash: Cash on hand', formatMoney(s.money)],
    ];
    this.panel.append(
      h('div', { style: { fontSize: '72px' }, text: won ? ':double-wide:' : ':clipboard:' }),
      h('h1', { text: won ? "MOVIN' ON UP!" : 'EVICTED' }),
      h('p', {
        text: won
          ? `${s.player.name} signed the papers on a DOUBLE WIDE. Two whole bathrooms. A pitched roof. Darlene cried a little. Earl fired a celebratory firework into the dumpster. You are, legally speaking, a land baron now. (You still rent the land.)`
          : `Darlene taped a bright orange notice to your door. "It ain't personal, sugar. It's Apex." Apex Capital Holdings LLC thanks you for your contribution to shareholder value. Your lot is being "repositioned as a premium opportunity."`,
      }),
      h(
        'div',
        { class: 'stats' },
        ...stats.flatMap(([k, v]) => [h('span', { text: k }), h('strong', { text: v })]),
      ),
      h(
        'div',
        { class: 'choices' },
        h('button', { class: 'tape primary', text: actions.primary[0], on: { click: actions.primary[1] } }),
        h('button', { class: 'tape', text: actions.secondary[0], on: { click: actions.secondary[1] } }),
      ),
    );
    this.el.hidden = false;
  }

  hide(): void {
    this.el.hidden = true;
  }
}
